// PROTOTYPE
import React from 'react'
import { Spacer, View } from 'oio-react'
import PropTypes from 'prop-types'

// TODO: Not sure how icon should work yet
const ProtoHeadingBlock = ({ colorMode, contentMaxWidth, description, metatext, title }) => (
   <View width="100%">
      <View paddingRight="50px">
         <div
            className="text-2xl tracking-tight font-semibold"
            style={{ color: colorMode === 'dark' ? '#fff' : '#000' }}>
            {title}
         </div>
      </View>
      <View width="100%">
         <View maxWidth={contentMaxWidth}>
            <Spacer size="2" />
            <div
               className="text-sm"
               style={{ color: colorMode === 'dark' ? 'rgba(255,255,255,0.4)' : '#555' }}>
               {description}
            </div>
         </View>
      </View>
      {metatext && (
         <div className="text-sm mt-2" style={{ color: colorMode === 'dark' ? '#555' : '#999' }}>
            {metatext}
         </div>
      )}
   </View>
)

ProtoHeadingBlock.propTypes = {
   colorMode: PropTypes.oneOf(['dark', 'light']),
   contentMaxWidth: PropTypes.string,
   description: PropTypes.string,
   metatext: PropTypes.string,
   title: PropTypes.string.isRequired
}

ProtoHeadingBlock.defaultProps = {
   colorMode: 'light',
   contentMaxWidth: '420px',
   description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
   metatext: undefined
}

export default ProtoHeadingBlock
